const SAME = 0;
const HIGHER = 1;
const LOWER = -1;

const compareVersions = function (currentVersion, compareVersion) {
    try {
        const leftSplit = currentVersion.split(".");
        const rightSplit = compareVersion.split(".");
        const length = Math.max(leftSplit.length, rightSplit.length);
        for (let i = 0; i < length; i++) {
            if (
                (leftSplit[i] && !rightSplit[i] && parseInt(leftSplit[i]) > 0) ||
                parseInt(leftSplit[i]) > parseInt(rightSplit[i])
            ) {
                return HIGHER;
            } else if (
                (rightSplit[i] && !leftSplit[i] && parseInt(rightSplit[i]) > 0) ||
                parseInt(leftSplit[i]) < parseInt(rightSplit[i])
            ) {
                return LOWER;
            }
        }
    } catch (e) {
        return LOWER;
    }
    return SAME;
};
export default compareVersions;

export const VERSION_CM_3963_ADD_ASSET_TYPE = "1.0.7";
export const VERSION_CM_4214_ASSET_DOWNLOAD = "1.0.8";
export const VERSION_CM_3339_TIMELINE_ANALYSIS = "1.0.10";
export const VERSION_CM_4557_HIDDEN_METADATA = "1.0.11";
export const VERSION_CM_4604_SITE_ACCESS = "1.0.12"; // Sources (Storage)
export const VERSION_CM_2654_ARCHIVE_ASSET = "1.0.13";
export const VERSION_CM_4601_MUSIC_CONTENTS = "1.0.13";
export const VERSION_CM_4601_PHOTO_CONTENTS = "1.0.13";
export const VERSION_CM_4717_ASSET_DOWNLOAD_V2 = "1.0.14";
export const VERSION_CM_4733_CREATE_METADATA = "1.0.14";
export const VERSION_CM_4721_SHARES = "1.0.14";
export const VERSION_CM_4750_UPLOAD_FOLDERS = "1.0.14";
export const VERSION_CM_4718_IMAGE_VIEWER = "1.0.14";
export const VERSION_CM_4716_INTEGRATED_SEARCH = "1.0.14";
export const VERSION_CM_4923_FILE_META_SEARCH = "1.0.15";
export const VERSION_CM_4838_SHARE_MANAGEMENT = "1.0.15";
export const VERSION_CM_4869_ELEMENT_VERSION = "1.0.15";
export const VERSION_CM_4840_SHARED_ASSET_DETAIL = "1.0.15";
export const VERSION_CM_5068_ASSET_OWNER_CHANGE = "1.0.15";
export const VERSION_SHARED_ASSET_SEARCH = "1.0.15";
export const VERSION_CM_5058_DASHBOARD = "1.0.16";
export const VERSION_CM_5579_ALL_PROJECTS = "1.0.16";
export const VERSION_CM_5112_PROJECT_SITE_ACCESS = "1.0.16";
export const VERSION_CM_5162_PREVIEW_POPUP = "1.0.16";
export const VERSION_CM_5716_ELEMENT_UUID = "1.0.17";
export const VERSION_CM_5182_ASSET_DELETE_WITH_REFERENCE = "1.0.17";
export const VERSION_CM_5214_ADMIN = "1.0.17";
export const VERSION_SOURCE_VIEW_MUTATION = "1.0.17";
export const VERSION_MY_JOBS_PANEL = "1.0.17";
export const VERSION_SOURCE_VIEW_NEW_FOLDER = "1.0.17";
export const VERSION_SOURCE_DOWNLOAD = "1.0.19";
export const VERSION_CM_6169_SOURCE_MULTI_ASSET_CREATE = "1.0.20"; // SHARE_BOX 도입
export const VERSION_CM_5929_CHANNEL_LIVE_CAPTION = "1.0.21";
export const VERSION_CM_6155_CATEGORY_BULK = "1.0.22";
export const VERSION_CM_6286_METADATA_SELECT_FIELD = "1.0.22";
export const VERSION_CM_6345_CATEGORY_BULK_VIDEO = "1.0.23";
export const VERSION_CM_6351_LIVE_CAPTION_SYNC = "1.0.23";
export const VERSION_CM_6333_LISTINGS_VIDEO = "1.0.23";
export const VERSION_ACCOUNT_LAZY_SYNC = "1.0.23";
export const VERSION_ADMIN_STORAGE_UPLOADABLE_DOWNLOADABLE = "1.0.26";
export const VERSION_CM_6575_ASSET_CATEGORY_GROUP_SEARCH = "1.0.27";
export const VERSION_CM_6657_VIDEO_CATEGORY_GROUP_SEARCH = "1.0.28";
export const VERSION_CM_6707_CONTENTS_CATEGORY_GROUP_SEARCH = "1.0.29";
export const VERSION_CM_6839_STORAGE_SYNC_STATUS_CHECK = "1.0.31";
export const VERSION_CM_6932_STORAGE_PROJECT_MAPPING = "1.0.32";
export const VERSION_CM_7104_STORAGE_TOKEN_BASE_PAGINATION = "1.0.35";
export const VERSION_CM_7307_DOWNLOAD = "1.0.44";
export const VERSION_CM_7349_CREATE_ASSETS_BULK = "1.0.43"; //"1.0.42";
export const VERSION_CM_7441_STORAGE_PREVIEW = "1.0.43";
export const VERSION_CM_7510_SAFARI_ENCODING = "1.0.44";
export const VERSION_SAFARI_ENCODING_FOR_PRESIGN_AND_UPLOAD = "1.0.45";
export const VERSION_CM_7497_INTEGRATED_SEARCH_WITH_SEARCH_ENGINE = "1.0.46";
export const VERSION_CM_7564_SETTINGS_SEARCHABLE = "1.0.46";
export const VERSION_FMS_SAFARI_ENCODING = "1.0.46";
export const VERSION_CM_7791_CREATE_ASSET_MULTIPART = "1.0.47";
export const VERSION_CM_7794_STORAGE_DOWNLOAD_LINK = "1.0.48";
export const VERSION_CM_8075_SHARE_REQUEST = "1.0.48";
export const VERSION_CM_8260_SHARED_BOX_STORAGE_PROPERTY_PANEL = "1.0.48";
export const VERSION_CM_8339_FOLDER_VIEW = "1.0.53";
export const VERSION_CM_8606_OBJECT_UPDATE_STATUS = "1.0.53";
export const VERSION_CM_8558_METADATA_TEMPLATE = "1.0.53";
export const VERSION_CM_8667_STORAGE_V3 = "1.0.55";
export const VERSION_CM_8635_ASSET_BULK_METADATA_TEMPLATE = "1.0.55";
export const VERSION_CM_8782_ASSET_SHARE_LINK = "1.0.57";
export const VERSION_CM_8742_ASSET_SHARE_REQUEST = "1.0.57";
export const VERSION_CM_8731_ASSET_DOWNLOAD_JOBS = "1.0.57";
export const VERSION_CM_8998_ASSET_ARCHIVE = "1.0.58";
export const VERSION_CM_9213_ASSET_MULTI_DOWNLOAD = "1.0.62";
export const VERSION_CM_9213_ASSET_MULTI_EXTERNAL_SHARE = "1.0.62";
export const VERSION_VIDEO_PUBLISHING = "1.0.62";
export const VERSION_CM_9322_EXTERNAL_SHARE_HISTORY = "1.0.66";
export const VERSION_CM_9337_RECENT_ASSET_SHARED_ME = "1.0.66";
export const VERSION_CM_9369_EXTERNAL_SHARE_HISTORY_PROPERTY_PANEL = "1.0.66";
export const VERSION_CM_9436_EVENT_TRIGGER_VIRTUAL_FOLDER = "1.0.69";
export const VERSION_CM_9496_ARCHIVED_VIRTUAL_FOLDER = "1.0.71";
export const VERSION_CM_9545_STORAGE_LOCK = "1.0.72";
export const VERSION_CM_9596_UPLOAD_RESUME = "1.0.73";
export const VERSION_CM_9660_BULK_ARCHIVE_RESTORE = "1.0.74";
export const VERSION_CM_9751_CPD_INTEGRATIONS = "1.0.75";
export const VERSION_CM_9766_COLLECTIONS = "1.0.76";
export const VERSION_CM_10084_CREATE_ASSETS_WITH_COLLECTIONS = "1.0.77";
export const VERSION_CM_10137_CUSTOM_CONTENT_SCHEMAS = "1.0.80";
export const VERSION_CM_10226_VIDEO_MULTIPART_UPLOAD = "1.0.82";
export const VERSION_CM_10269_CUSTOM_CONTENTS = "1.0.82";
export const VERSION_CM_10347_DETAIL_CUSTOM_CONTENTS = "1.0.82";
export const VERSION_CM_10454_CREATE_AUTO_CAPTIONS = "1.0.84";
export const VERSION_CM_10454_VIDEO_DOWNLOAD = "1.0.84";
export const VERSION_CM_10567_VOCABULARY = "1.0.84";
export const VERSION_CM_10617_EVENT_TRIGGER_AUTO_CAPTIONS = "1.0.84";
export const VERSION_CM_10808_AI_ANALYSIS = "1.0.88";
export const VERSION_CM_10877_ASSET_CUSTOM_METADATA = "1.0.89";
export const VERSION_CM_10929_ASSET_REPLIES = "1.0.89";
export const VERSION_CM_11123_ROLES_V2 = "1.0.93";
export const VERSION_CM_11119_USER_INVITATION = "1.0.93";
export const VERSION_CM_11214_DASHBOARD_ADVANCEMENT = "1.0.93";
export const VERSION_CM_11164_COLLECTION_FOLDER_VIEW = "1.0.94";
export const VERSION_CM_11376_SHARES_V2 = "1.0.95";
export const VERSION_CM_11160_ASSET_LINKED_ASSETS = "1.0.93";
export const VERSION_CM_11155_ASSET_ROLES_VALIDATION = "1.0.93";
export const VERSION_CM_11210_ASSET_DUPLICATION = "1.0.94";
export const VERSION_CM_11345_PROJECT_COMMENT_SERVICE = "1.0.95";
export const VERSION_CM_11209_ADD_CUSTOM_METADATA = "1.0.95";
export const VERSION_CM_11330_USERS_TEAMS_ACCESS_V3 = "1.0.95";
export const VERSION_CM_11273_DEFAULT_CUSTOM_METADATA = "1.0.97";
export const VERSION_CM_11609_DEFAULT_ASSET_VIEW_MODE = "1.0.97";
export const VERSION_CM_11777_PROJECT_SETTINGS_ADD_MENU_NAME = "1.0.98";
export const VERSION_CM_12123_METADATA_EXPORT = "1.0.100";
export const VERSION_CM_12200_CREATE_COLLECTION_WITH_ASSET_FOLDER = "1.0.101";
export const VERSION_CM_12290_COLLECTION_ARCHIVE = "1.0.101";
export const VERSION_CM_12343_ASSET_UPLOAD_PREVIEW_IMAGE = "1.0.102";
export const VERSION_CM_12198_COLLECTION_DOWNLOAD = "1.0.102";
export const VERSION_CM_12197_COLLECTION_SHARE_LINK = "1.0.102";

// NOTE: 모든 고객이 1.0.106 이상의 버전으로 사용하고 있음
export const VERSION_CM_12411_ADMIN_AUDIT_LOGS = "1.0.106";
export const VERSION_CM_12592_VIDEO_EDIT = "1.0.106";
export const VERSION_CM_12619_REPORTS = "1.0.106";
export const VERSION_CM_12725_ASSET_AUTO_ARCHIVE = "1.0.109";
export const VERSION_CM_12844_CUSTOM_CONTENT_DESCRIPTION = "1.0.109";
export const VERSION_CM_12826_CUSTOM_CONTENT_FOLDER_VIEW = "1.0.109";
export const VERSION_CM_12666_PROJECT_DEFAULT_CLIPPING_PIPELINE = "1.0.106";
export const VERSION_CM_12923_LIST_SEARCHBAR_FILTER = "1.0.111";
export const VERSION_CM_12797_GET_USERS_WITH_ACTION_GROUP_IDS = "1.0.109";
export const VERSION_CM_13056_REPORT_FILE_SIZE_BY_PROJECTS = "1.0.111";
export const VERSION_CM_13225_COMMENT_DISPLAY = "1.0.113";
export const VERSION_CM_13231_ASSET_ACTIVITY_HISTORY = "1.0.114";
export const VERSION_CM_13303_PREVIEW_CROP = "1.0.115";
export const VERSION_CM_13445_CUSTOM_MENU_SETTING = "1.0.115";
export const VERSION_CM_13539_DEFAULT_MENU_SETTING = "1.0.115";
export const VERSION_CM_13540_ASSET_SEARCH_BAR_V2 = "1.0.121";
export const VERSION_CM_13925_OWNER_LOCK = "1.0.121";
export const VERSION_CM_14205_ASSET_STARRED = "1.0.121";
export const VERSION_CM_14175_ASSET_LOCK_WHILE_CREATE = "1.0.122";
export const VERSION_CM_13766_SHARES_V3 = "1.0.122";
export const VERSION_CM_14143_REQUEST = "1.0.122";
export const VERSION_CM_14113_USER_INVITATION_V2 = "1.0.123";
export const VERSION_CM_13806_CUSTOM_MENU_MAIL_LINK = "1.0.123";
export const VERSION_CM_14011_USER_AGREEMENT = "1.0.125";
export const VERSION_CM_14830_SEPARATION_OF_OWNER_AND_CREATOR = "1.0.126";
export const VERSION_CM_14828_EVENT_TRIGGER_AUTO_VIRTUAL_FOLDER = "1.0.126";
export const VERSION_CM_14991_ASSET_GROUPED_BY_MEDIA_TYPE_SETTINGS = "1.0.128";
export const VERSION_CM_15140_USER_MANAGEMENT_V2_SEARCH_FILTER = "1.0.129";
export const VERSION_CM_15135_ADMINISTRATION_SETTINGS_STORAGE = "1.0.129";
export const VERSION_CM_15200_PROJECT_MULTI_ACCOUNT = "1.0.129";
export const VERSION_CM_15198_ASSET_SEARCHBAR_LOCKED_STATE = "1.0.130";
export const VERSION_CM_15199_MULTI_ASSETS_OWNER_CHANGE = "1.0.130";
export const VERSION_CM_15302_PROJECT_SETTING_AI_AUTO_TAGGING = "1.0.132";
export const VERSION_CM_15264_ADMIN_USAGE_METRICS = "1.0.133";
export const VERSION_CM_15265_ADMIN_ROLE_USER_GROUP_MANAGEMENT = "1.0.134";
export const VERSION_CM_14973_DISPLAY_INVITED_INFO = "1.0.135";
export const VERSION_CM_15543_AI_WORKSPACE = "1.0.135";
export const VERSION_CM_15524_NOTIFY_POPPER = "1.0.135";
export const VERSION_CM_15774_PROMPT_PRESETS = "1.0.138";
export const VERSION_CM_15864_ITEM_SETS_V3 = "1.0.138";
export const VERSION_CM_15776_DELETE_INPUTS_SETTINGS = "1.0.138";
export const VERSION_CM_15880_VIDEO_SHARE_INFO = "1.0.140";
export const VERSION_CM_16021_ASSET_INGEST_TYPE_SETTINGS = "1.0.140";
export const VERSION_CM_16070_PROXY_VIDEO_SETTINGS = "1.0.140";
export const VERSION_CM_16961_AUTOMATED_WORKFLOW = "1.0.147";
export const VERSION_CM_16963_PROJECT_SETTING_AI_SEARCH = "1.0.150";
export const VERSION_DAM_28_ASSET_INDEX_STATUS = "1.0.151";
export const VERSION_DAM_29_ASSET_INDEX = "1.0.151";
export const VERSION_DAM_23_USER_LIST_EXPORT = "1.0.151";
export const VERSION_DAM_135_AI_BILLING = "1.0.152";
export const VERSION_DAM_216_ASSET_PUBLIC_URL = "1.0.153";
export const VERSION_DAM_275_ASSET_SEARCH_INDEX_STATUS = "1.0.153";
export const VERSION_DAM_350_ASSET_BULK_INDEX_RETRY = "1.0.153";
export const VERSION_DAM_228_FOLDER_TREE_DND = "1.0.153";
export const VERSION_DAM_463_LANGUAGE_PT_ZH = "1.0.153";
export const VERSION_DAM_372_WEBHOOK = "1.0.154";
export const VERSION_DAM_604_ASSET_INDEX_ENGINES = "1.0.155";
export const VERSION_DAM_599_ASSET_PUBLIC_URL_STATISTICS = "1.0.155";
// 상위 스토리 DAM-461(전송 이력 확인) 번호를 쓴다(구현 티켓은 DAM-866). 전송 이력 API(GET /webhooks/{id}/histories) 동반 배포 전제 — BE 배포 버전이 다르면 조정.
export const VERSION_DAM_461_WEBHOOK_HISTORIES = "1.0.156";
export const VERSION_DAM_934_INVITATION_MAIL_LANGUAGE = "1.0.157";
// 해시태그 조회 API(GET /hashtags) 동반 배포 전제 — BE 배포 버전이 다르면 조정.
export const VERSION_DAM_891_HASHTAG_SUGGESTIONS = "1.0.157";
export const VERSION_DAM_878_EXTERNAL_SHARE_REVOKE = "1.0.157";
